/* ==========================================================================
   Customisations Dabeull — volet JS de custom.css, chargé par theme.liquid.
   Fichier volontairement séparé des assets RoarTheme : il survit tel quel
   aux mises à jour du thème Concept.

   Compatibilité PreOrder Globo (voir docs/preorder/README.md). Deux volets :

   A. Quick view — Globo sait gérer les modales de quick view
      (initCollectionQuickview), mais ne se déclenche jamais ici : sa liste
      de sélecteurs déclencheurs contient « .quick-view », qui désigne le
      bouton dans la plupart des thèmes alors que Concept l'emploie pour la
      modale elle-même. Le vrai déclencheur, .quick-view__button, n'est donc
      jamais reconnu. Sans ce relais, la modale ajoute au panier sans
      selling plan ni propriété : la commande n'est pas marquée
      pré-commande. On appelle donc la fonction de Globo à la main sur
      l'événement quickview:loaded émis par le thème.

   B. Boutons clonés — Globo clone le bouton add-to-cart du thème. Trois
      dégâts au passage :
      1. le libellé est recopié dans le calque d'animation .btn-fill,
         normalement vide ;
      2. sur les cartes produit, le libellé visible reste « Add to cart »
         (Globo n'a écrit le sien que dans le calque) ;
      3. le clone est créé hors DOM, donc le constructeur HoverButton
         (theme.js) ne trouve pas de formulaire associé et n'attache jamais
         l'écouteur submit qui déclenche le loader à 3 points — l'état
         aria-busy ne s'applique qu'au bouton d'origine, resté masqué.
         Globo insère par ailleurs son clone *après* l'original dans le
         formulaire : ProductForm.submitButton, qui vaut
         querySelector('[type="submit"]'), désigne donc le bouton masqué.
         C'est lui qui reçoit puis perd aria-busy à chaque ajout, pendant
         que le bouton réellement affiché n'est jamais remis à zéro.
   ========================================================================== */
(function () {
  "use strict";

  /* ---- A. Relais du quick view vers Globo ---- */

  function handleFromUrl(url) {
    var match = String(url || "")
      .split("?")[0]
      .match(/\/products\/([^/]+)\/?$/);
    return match ? match[1] : null;
  }

  function relayQuickViewToGlobo(productUrl) {
    var app = window.Globo && window.Globo.Preorder;
    if (!app || typeof app.initCollectionQuickview !== "function") return;

    var handle = handleFromUrl(productUrl);
    if (!handle) return;

    // Globo repart de l'élément porteur de [preorder-product-element] pour
    // retrouver la fiche produit dans ses réglages ; sur Concept c'est le
    // lien image de la carte, pas le bouton de quick view.
    var anchor = document.querySelector('[preorder-product-element][d-handle="' + handle + '"]');
    if (!anchor) return;

    // La modale de Concept contient deux formulaires /cart/add : celui du
    // paiement en plusieurs fois d'abord, le vrai formulaire produit
    // ensuite. Le sélecteur générique de Globo retient le premier et pose
    // le selling plan au mauvais endroit : le bouton « Add to cart » natif
    // reste alors actif sur un formulaire non marqué. On restreint donc la
    // recherche au formulaire produit.
    if (app.settings && app.settings.selectors) {
      app.settings.selectors.quickViewProductForm = '.quick-view form.product-form[action*="/cart/add"]';
    }

    app.initCollectionQuickview(anchor);
  }

  document.addEventListener("quickview:loaded", function (event) {
    relayQuickViewToGlobo(event.detail && event.detail.productUrl);
  });

  /* ---- B. Réparation des boutons clonés ---- */

  function keepFillEmpty(fill) {
    if (fill.textContent !== "") fill.textContent = "";
    if (fill.__preorderFillObserver) return;
    // Globo réécrit le libellé dans le calque après coup (chargement
    // asynchrone de ses traductions) : on le revide à chaque réécriture.
    fill.__preorderFillObserver = new MutationObserver(function () {
      if (fill.textContent !== "") fill.textContent = "";
    });
    fill.__preorderFillObserver.observe(fill, { childList: true, characterData: true, subtree: true });
  }

  function applyLabel(btn, label) {
    var text = btn.querySelector(".btn-text");
    if (!text || !label) return;
    // Sur les cartes produit, .btn-text contient une icône puis un span de
    // libellé : on ne remplace que ce span pour préserver l'icône.
    var span = text.querySelector("span");
    var target = span || text;
    if (target.textContent.trim() !== label) target.textContent = label;
  }

  function fixPreorderButtons() {
    document.querySelectorAll(".gPreorderBtn").forEach(function (btn) {
      var fill = btn.querySelector(".btn-fill");
      // Le calque pollué porte le libellé configuré dans Globo : on le lit
      // avant de le vider, c'est notre seule source pour les cartes.
      var label = fill ? fill.textContent.trim() : "";
      if (fill) keepFillEmpty(fill);
      if (!label) {
        var text = btn.querySelector(".btn-text");
        label = text ? text.textContent.trim() : "";
      }
      applyLabel(btn, label);

      var loaders = btn.querySelectorAll(".btn-loader");
      for (var i = 1; i < loaders.length; i++) loaders[i].remove();

      // On désigne le clone visible comme bouton de soumission du
      // formulaire, à la place du bouton d'origine masqué que le thème
      // retiendrait (ProductForm.submitButton mémorise le premier
      // [type="submit"] du formulaire, or Globo insère son clone après).
      // Le thème pose alors lui-même aria-busy et aria-disabled sur le
      // bouton affiché, et surtout les retire dans son bloc `finally` —
      // donc sur toutes les sorties : succès, erreur panier, échec réseau.
      //
      // Relayer nous-mêmes aria-busy au submit ne suffisait pas : rien ne
      // le retirait ensuite. Sur le quick add, le bouton de la carte restait
      // indéfiniment en loader à 3 points après la fermeture du tiroir.
      // Cela aligne aussi le garde-fou anti-double-envoi
      // (`if (this.submitButton.hasAttribute('aria-disabled')) return`) sur
      // le bouton que le client clique réellement.
      //
      // On complète au passage la liste que le thème nettoie
      // (ProductForm.submitButtons, sinon limitée aux boutons liés par
      // l'attribut form=, comme le bouton sticky) avec les boutons internes
      // au formulaire : sans cela le bouton d'origine masqué conserverait
      // indéfiniment l'aria-busy que lui pose HoverButton au submit — un
      // loader figé, invisible tant que Globo le masque.
      if (btn.form) {
        btn.form._submitButton = btn;

        var formId = btn.form.getAttribute("id");
        var linked = formId ? document.querySelectorAll('[type="submit"][form="' + formId + '"]') : [];
        btn.form._submitButtons = [].concat(
          [].slice.call(btn.form.querySelectorAll('[type="submit"]')),
          [].slice.call(linked),
        );
      }

      // Le bouton sticky (sticky_buy_button, main-product.liquid) soumet le
      // même formulaire — l'achat est donc bien marqué pré-commande — mais
      // son libellé Liquid ne connaît que le template_suffix « pre-order »,
      // pas les offres Globo : il affiche encore « Add to cart ». On
      // recopie le libellé du bouton principal (pas ceux des cartes de
      // recommandation, qui concernent d'autres produits).
      if (label && btn.classList.contains("product-form__submit")) {
        document
          .querySelectorAll('product-sticky-form button[type="submit"] .btn-text span:last-child')
          .forEach(function (span) {
            if (span.textContent.trim() !== label) span.textContent = label;
          });
      }
    });
  }

  /* ---- C. Étiquette pré-commande dans le panier ---- */

  // Le thème n'affiche pas les propriétés de ligne préfixées « _ »
  // (convention Shopify pour les données techniques) : la ligne d'un article
  // en pré-commande n'affiche donc que le nom du selling plan, « Full
  // Payment », qui ne dit rien au client. Le module panier de Globo, lui, ne
  // reconnaît pas le balisage de Concept (ses sélecteurs attendent
  // .cart-item, .line-item…, le thème utilise .horizontal-product).
  // On remplace donc nous-mêmes ce nom par le libellé pré-commande, qui
  // porte la date d'expédition.
  var cartLabelPending = false;

  function decorateCartLines() {
    if (cartLabelPending) return;
    var links = document.querySelectorAll('a[href*="/cart/change?id="]');
    if (!links.length) return;

    cartLabelPending = true;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart.js" : "/cart.js", {
      headers: { Accept: "application/json" },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var byKey = {};
        cart.items.forEach(function (item) {
          var note = item.properties && item.properties._is_preorder;
          if (note) {
            byKey[item.key] = {
              note: note,
              planName: item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : null,
            };
          }
        });

        document.querySelectorAll('a[href*="/cart/change?id="]').forEach(function (link) {
          var match = link.getAttribute("href").match(/[?&]id=([^&]+)/);
          if (!match) return;
          var info = byKey[decodeURIComponent(match[1])];
          if (!info) return;

          // Tiroir panier : lignes en <li>. Page panier : lignes en <tr>.
          var line = link.closest("tr, li") || link.closest(".horizontal-product");
          if (!line) return;

          // Le nom du selling plan occupe déjà la ligne sous le titre :
          // on écrit le libellé à sa place plutôt que d'empiler les deux.
          var target = null;
          if (info.planName) {
            target = [].slice.call(line.querySelectorAll("p")).filter(function (p) {
              return p.textContent.trim() === info.planName;
            })[0];
          }
          if (target) {
            if (target.textContent.trim() !== info.note) target.textContent = info.note;
            return;
          }

          // Pas de selling plan affiché (paiement intégral masqué, autre
          // gabarit de ligne) : on ajoute le libellé sous le titre.
          if (line.querySelector("[data-preorder-cart-note]")) return;
          var title = line.querySelector('a[href*="/products/"]');
          if (!title) return;
          var el = document.createElement("p");
          el.className = "text-xs text-opacity";
          el.setAttribute("data-preorder-cart-note", "");
          el.textContent = info.note;
          (title.parentElement || line).appendChild(el);
        });
      })
      .catch(function () {
        /* panier indisponible : on laisse le rendu du thème tel quel */
      })
      .then(function () {
        cartLabelPending = false;
      });
  }

  var observer = new MutationObserver(function (mutations) {
    var seenPreorderButton = false;
    var seenCartLine = false;

    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (
          (node.matches && node.matches(".gPreorderBtn")) ||
          (node.querySelector && node.querySelector(".gPreorderBtn"))
        ) {
          seenPreorderButton = true;
        }
        if (
          (node.matches && node.matches('a[href*="/cart/change?id="]')) ||
          (node.querySelector && node.querySelector('a[href*="/cart/change?id="]'))
        ) {
          seenCartLine = true;
        }
      }
    }

    if (seenPreorderButton) fixPreorderButtons();
    if (seenCartLine) decorateCartLines();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  fixPreorderButtons();
  decorateCartLines();
})();
